import {useMemo} from 'react'
import {IPhoto} from 'screens/Patients/LeadsProfile/leadsProfile.types'
import PhotosRow from './PhotosRow'
import When from 'components/when/When'
import hasValue from 'utils/hasValue'
import {getImageUrl} from 'utils/ConstFunctions'

const AlignerPhotoSection = ({alignerPhotos}: {alignerPhotos: IPhoto[]}) => {
  const mapPhoto = (photo: IPhoto) => {
    const url = getImageUrl(photo)
    const type = (photo as any)?.type ?? (photo as any)?.file_type ?? 'image/jpeg'
    if (!url) return null
    return {
      name: photo.image_name,
      url,
      type,
    }
  }

  const withAlignerPhotos = useMemo(
    () =>
      alignerPhotos
        .filter((photo) => photo.with_aligner)
        .map(mapPhoto)
        .filter(Boolean) as {name: string; url: string; type: string}[],
    [alignerPhotos]
  )

  const withoutAlignerPhotos = useMemo(
    () =>
      alignerPhotos
        .filter((photo) => !photo.with_aligner)
        .map(mapPhoto)
        .filter(Boolean) as {name: string; url: string; type: string}[],
    [alignerPhotos]
  )
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-col gap-4'>
        <When isTrue={hasValue(withAlignerPhotos)}>
          <PhotosRow fileUrls={withAlignerPhotos} photoType='With aligners' />
        </When>
        <When isTrue={hasValue(withoutAlignerPhotos)}>
          <PhotosRow fileUrls={withoutAlignerPhotos} photoType='Without aligners' />
        </When>
      </div>
    </div>
  )
}

export default AlignerPhotoSection
